import { CurrenciesSymbols, Currencies } from "@obby/constants";

export function CurrencyISO__CurrencySymbol(isoCode: string = Currencies.GBP) {
  return CurrenciesSymbols[isoCode.toUpperCase()] || "£";
}
